/**
 * Footer. Policy pages live on /legal.
 */
import { useTheme } from '../ThemeContext';
import { COMPANY, LEGAL_INDEX_PATH, followPolicyLink } from '../utils/legal';

const Footer = () => {
  const { colors } = useTheme();
  const currentYear = new Date().getFullYear();

  return (
    <footer style={{...styles.footer, background: colors.surfaceAlt, borderTop: `1px solid ${colors.borderLight}`}}>
      <div style={styles.container}>
        <nav aria-label="Legal" style={styles.links}>
          <a
            href={LEGAL_INDEX_PATH}
            onClick={followPolicyLink}
            style={{...styles.link, color: colors.textSecondary}}
          >
            Legal
          </a>
        </nav>
        <p style={{...styles.copyright, color: colors.textSecondary}}>
          © {currentYear} {COMPANY.legalName}
          {' · '}
          {COMPANY.address}
          {' · '}
          <a href={`mailto:${COMPANY.email}`} style={{...styles.link, color: colors.textSecondary}}>
            {COMPANY.email}
          </a>
        </p>
      </div>
    </footer>
  );
};

const styles = {
  footer: {
    padding: '1.5rem 0',
    marginTop: 'auto',
    width: '100%'
  },
  container: {
    maxWidth: '1200px',
    margin: '0 auto',
    padding: '0 1rem',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    gap: '0.75rem',
    textAlign: 'center'
  },
  copyright: {
    fontSize: '0.85rem',
    margin: 0,
    fontWeight: 300,
    letterSpacing: '0.02em',
    lineHeight: 1.5
  },
  links: {
    display: 'flex',
    gap: '0.75rem',
    alignItems: 'center',
    flexWrap: 'wrap',
    justifyContent: 'center'
  },
  link: {
    fontSize: '0.85rem',
    textDecoration: 'none',
    padding: '0.25rem 0.5rem',
    fontWeight: 300,
    letterSpacing: '0.02em'
  },
  separator: {
    fontSize: '0.85rem',
    opacity: 0.5
  }
};

export default Footer;
